import React from 'react';

import { ProgressBar, ProgressBarItem, Container } from './style';

interface Props {
  size: number;
  currentStep: number;
}

const ProgressSteps = ({ size, currentStep }: Props) => {
  const renderProgressSteps = () => {
    const steps: JSX.Element[] = [];
    for (let index = 0; index < size; index += 1) {
      steps.push(<ProgressBarItem key={index} isActive={index <= currentStep} />);
    }

    return (
      <Container>
        <ProgressBar>{steps}</ProgressBar>
      </Container>
    );
  };

  return <>{renderProgressSteps()}</>;
};

export default ProgressSteps;
